export default [function HiddenController() {}];
